import { useRef,  useState , memo , useCallback} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import List from '@mui/material/List';
import {useFetchFlowers} from '../hooks/useFetchFlowers'
import {useFetchHistory} from '../hooks/useFetchHistory'
import {useFetchStation} from '../hooks/useFetchStation'
import ListItem from '@mui/material/ListItem';
import CardMedia from '@mui/material/CardMedia';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import {useSharedLang} from '../hooks/useSharedLang.js';
import {LANGS } from "../components/constants.js";
import {getLink} from "../utils/UrlUtil.js";
import Loading from "../components/Loading.js";

const Search = memo(() => {
    const {flowerList, isLoadingFlowers} = useFetchFlowers();
    const {historyList, isLoadingHistory} = useFetchHistory();
    const {stationList, isLoadingStation} = useFetchStation();

    const searchKeyword = useRef(null);
    //const [searchKeyword, setSearchKeyword] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const { t } = useTranslation();
    const { sharedLang } = useSharedLang();

    const onInput =  (e) => {
        // 入力キーワードをstateに格納する
        //setSearchKeyword(e.target.value);
        searchKeyword.current = e.target.value.trim();
        search();
    };

    const search = useCallback(() => {
        let tmp = [];
        let Data = flowerList.concat(historyList).concat(stationList);

        if(searchKeyword.current === ''){
            setSearchResults(tmp);
        }

        Data.forEach(element => {
            if (
                searchKeyword.current !== '' && //空文字検索するとアプリが落ちてしまうので予防線
                (element.name.indexOf(searchKeyword.current) !== -1 ||
                  element.description.indexOf(searchKeyword.current) !== -1 ||
                  element.tag.indexOf(searchKeyword.current) !== -1)
              ) {
                if(sharedLang === LANGS.ENGLISH){
                    element.name = element.nameEnglish;
                    element.description = element.descriptionEnglish;
                }          
                tmp.push(element);
              }
        });
        setSearchResults(tmp);
    },[flowerList,historyList,stationList,sharedLang]);
    
    const nl2comma = useCallback((str) => {
        if(!str){
            return "";
        }
        str = str.substring(0, 30) + "…";
        return str.replaceAll("¥/", "、");
    },[]);

    // const getLink = useCallback((elem) => {
    //     let category = elem.category;
    //     if (category === 'flower') {
    //         return "/nature/" + elem.id;
    //     }
    //     else if (category === 'history') {
    //         return "/history/" + elem.id;
    //     }
    //     else if (category === 'station' || category === 'restaurant') {
    //         return "/station/" + elem.id;
    //     }

    // },[]);

    if (isLoadingFlowers || isLoadingHistory || isLoadingStation) {
        return (<Loading></Loading>);
    }
    
    return (
        <Box className="search">
            <AppBar className="search-bar" position="static">
                <div className="title1">
                {t("search.title")} 
                </div>
                <div className="title2">
                {t("search.subtitle")} 
                </div>
                <div className="search-comment">
                {t("search.note")} 
                
                    <div className='search-content-box'>
                    <input type="text" onInput={onInput}></input>
                    <SearchIcon />
                    </div>
                </div>
            </AppBar>
            {searchResults.length === 0?<>empty</>:<></>}
            <List className="search-list">
            {
            searchResults.map((element, index) => 
                <ListItem alignItems="flex-start" key={index}>
                <Link to={getLink(element)}>
                <Card className={"searchListItem"}>
                    <Box sx={{display:'flex'}}>
                        <CardMedia
                            component="img"
                            sx={{ width: 140 }}
                            image={"/assets/images/descriptions/" + element.path}
                        />
                    <Box sx={{ display: 'block'}}>
                    <CardContent sx={{ flex: '1 0 auto' }}>
                        <Typography component="div" variant="h5" className="title">
                            {element.name}
                        </Typography>
                        <Typography variant="subtitle1" component="div" sx={{ color: 'text.secondary', overflowWrap: 'break-word' }}>
                        {nl2comma(element.description)}
                        </Typography>
                    </CardContent>
                    </Box>
                    </Box>
                </Card>
                </Link>
                </ListItem>
            )
            }
            </List>            
        </Box>
    )
});
export default Search